// extracted by mini-css-extract-plugin
export var centerText = "_c3-8";
export var container = "_c3-0";
export var doughnutContainer = "_c3-7";
export var legend = "_c3-a";
export var legendItemColorDisplay = "_c3-b";
export var legendItemLabel = "_c3-d";
export var legendItemValue = "_c3-c";
export var lg = "_c3-5";
export var maxWidth = "_c3-9";
export var md = "_c3-4";
export var responsive = "_c3-6";
export var sm = "_c3-3";
export var xs = "_c3-2";
export var xxs = "_c3-1";